var id = 1;
var Shadow = /** @class */ (function () {
    function Shadow() {
        this.id = 'light-render-shadow-' + id++;
    }
    Shadow.prototype.setShadow = function (shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY) {
        this.shadowColor = shadowColor;
        this.shadowBlur = shadowBlur || 0;
        this.shadowOffsetX = shadowOffsetX || 0;
        this.shadowOffsetY = shadowOffsetY || 0;
    };
    Shadow.prototype.getSVGNode = function () {
        return {
            svgTagName: 'filter',
            svgAttr: {
                id: this.id,
                x: '-100%',
                y: '-100%',
                width: '300%',
                height: '300%',
            },
            childNodes: [
                {
                    svgTagName: 'feDropShadow',
                    svgAttr: {
                        dx: this.shadowOffsetX,
                        dy: this.shadowOffsetY,
                        'flood-color': this.shadowColor,
                        stdDeviation: this.shadowBlur / 2 + ' ' + this.shadowBlur / 2,
                    },
                },
            ],
        };
    };
    return Shadow;
}());
export default Shadow;
